/**
 * focusToButton
 * 要素の先頭と末尾どちらかにフォーカスを与える。
 * @param {DOM} parentElement 対象のモーダル要素
 * @param {Boolean} isFirstFocus 先頭と末尾のどちらにフォーカスを与えるか指定する。
 */
export function focusToButton(parentElement, isFirstFocus = true) {
  if (!parentElement) {
    throw new Error('要素が見つかりませんでした');
  }

  const focusableArray = createInteractiveElArray(parentElement);

  if (focusableArray.length > 0) {
    focusableArray[isFirstFocus ? 0 : focusableArray.length - 1].focus();
  }

  focusableArray[0].focus();
};

/**
 * modalFocus
 * モーダルのキーボードフォーカスを制御するイベント
 * @param {Event} event
 * @param {DOM} parentElement 対象のモーダル要素
 * @param {Function} onClose モーダルを閉じる処理
 */
export function modalFocus(event, parentElement, onClose) {
  if (!parentElement) {
    return;
  }

  switch (event.code) {
    case 'Enter':

    case 'Space':
      break;

    case 'Escape':
      onClose();
      break;

    case 'Tab': {
      // モーダル画面内にフォーカスが当たっているか検証
      const interactiveElArray = createInteractiveElArray(parentElement);
      const focusIndex = interactiveElArray.findIndex(el => el === document.activeElement);

      if (interactiveElArray.length === 1) {
        // フォーカス可能な要素が1つしかない場合、その要素のみフォーカス
        event.preventDefault();
        event.stopImmediatePropagation();
        focusToButton(parentElement, true);
        break;
      }

      if (focusIndex === 0) {
        if (event.shiftKey) {
          // モーダル画面以外にフォーカスが当たっていたらイベントを無効化
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, false);
        }
      } else if (focusIndex >= interactiveElArray.length - 1) {
        // 最後の要素にふれていたら1番目の要素にフォーカスをあてる
        if (!event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, true);
        }
      } else if (focusIndex === -1) {
        // 画面外の要素にフォーカスがあたっていたら1番目の要素にフォーカスをあてる
        focusToButton(parentElement, true);
      }

      break;
    }
  }
}

/**
 * createInteractiveElArray
 * 要素内にあるフォーカス可能な要素を取得する
 * @param {DOM} element モーダル要素
 * @returns {Array} 要素内にあるフォーカス可能な要素の配列
 */
function createInteractiveElArray(element) {
  const INTERACTIVE_SELECTOR = 'button, a';
  // モーダル要素内のフォーカス可能な要素を取得する
  const elements = element.querySelectorAll(INTERACTIVE_SELECTOR);
  const interactiveElArray = Array.from(elements);
  return interactiveElArray;
};